<template>

    <div class="widget-container" :class="type">

        <div class="widget-handle">
            <div class="widget-handle-details-container">
                <v-icon class="widget-type-icon">{{ icon }}</v-icon>
                <span class="widget-name" v-text="$props.widgetObj.name" />

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on" class="report-timer" @click="refreshReportResults" v-text="autoRefreshTimeLeftPretty" v-if="type == 'report'"></span>
                    </template>
                    <span>Click to Run</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="settingsClick" class="widget-settings-icon">settings</v-icon>
                    </template>
                    <span>Widget Settings</span>
                </v-tooltip>

                <v-tooltip bottom v-if="!expandWidgetState">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="expandWidget" class="widget-expand-icon">mdi-arrow-expand-all</v-icon>
                    </template>
                    <span>Widget Front-and-Center</span>
                </v-tooltip>
                
                <v-tooltip bottom v-if="expandWidgetState">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="retractWidget" class="widget-expand-icon">mdi-arrow-collapse</v-icon>
                    </template>
                    <span>Retract Widget</span>
                </v-tooltip>
            </div>
        </div>

        <div class="flip-card" :class="{'tab-active': showTab}">
            <div class="flip-card-inner" :class="{settings: showSettings}">

                <div class="widget-content">
                    <alarms :widgetMode="true" :widgetCommand="widgetCommand" v-if="type == 'alarms'"></alarms>
                    <issues :widgetMode="true" :widgetCommand="widgetCommand" v-if="type == 'issues'"></issues>
                    <geo-map :widgetMode="true" v-if="type == 'geomap' && (!$store.state.expressMode || $store.state.expressReady)"></geo-map>
                    <report-widget :widgetObj="$props.widgetObj" :widgetCommand="widgetCommand" @complete="refreshReportResultsComplete" v-if="type == 'report'" />
                    <dashboard :widgetMode="true" :tableauUrl="tableauUrl" v-if="type == 'tableau'"></dashboard>
                </div>

                <div class="widget-metadata">
                    <v-container>
                        <div class="section">
                            <v-text-field label="Widget Name" color="#ffffff" v-model="$props.widgetObj.name" />
                        </div>

                        <div class="section" v-if="type != 'geomap' && type != 'tableau'">
                            <span class="section-label">Widget View</span>
                            <div class="">
                                <v-select class="widget-option-select" outlined color="#c42111" :items="viewsList" v-model="selectedView" return-object item-text="view_name" @change="sendWidgetCommand('setView')">
                                    <template v-slot:item="{item}">
                                        <span v-text="item.view_name" />
                                        <span class="view-select-default-text" v-text="'DEFAULT'" v-if="item.default" />
                                    </template>
                                </v-select>
                                <v-btn class="ml-3" fab dark x-small color="#c42111" @click="sendWidgetCommand('clearView')" title="Clear View">
                                    <v-icon>mdi-layers-remove</v-icon>
                                </v-btn>
                                <v-switch class="favsToggle" color="#c42111" label="Fav Views/All Views" v-model="viewListAll" />
                            </div>
                        </div>

                        <div class="section" v-if="type != 'geomap' && type != 'tableau'">
                            <span class="section-label">Density</span>
                            <v-select class="widget-option-select" outlined color="#c42111" :items="['Comfortable', 'Compact']" v-model="selectedDensity" @change="sendWidgetCommand('setDensity')" />
                        </div>

                        <div class="section" v-if="type == 'tableau'">
                            <span class="section-label">Default Tableau Tab</span>
                            <v-autocomplete autocomplete="off" class="widget-option-select" outlined color="#c42111" item-text="name" return-object :items="$props.widgetObj.tableauTabs" v-model="$props.widgetObj.selectedTableauTab" @change="sendWidgetCommand('setDensity')" />
                        </div>

                        <div class="section">
                            <div style="display: inline-block">
                                <span class="section-label">Position</span>
                                <v-text-field class="input-field" label="Offest Left" color="#ffffff" outlined suffix="%" type="number" min="0" max="100" v-model="widgetOffsetLeftPct" readonly dense />
                                <v-text-field class="input-field" label="Offest Top" color="#ffffff" outlined suffix="%" type="number" min="0" max="100" v-model="widgetOffsetTopPct" readonly dense />
                                <!-- <v-btn class="input-field" max-width="100" light width="100%" height="50" @click="">Apply</v-btn> -->
                            </div>
                            <div style="display: inline-block">
                                <span class="section-label">Size</span>
                                <v-text-field class="input-field" label="Width" color="#ffffff" outlined suffix="%" type="number" min="0" max="100" v-model="widgetWidthPct" readonly />
                                <v-text-field class="input-field" label="Height" color="#ffffff" outlined suffix="%" type="number" min="0" max="100" v-model="widgetHeightPct" readonly />
                                <!-- <v-btn class="input-field" max-width="100" light width="100%" height="50">Apply</v-btn> -->
                            </div>
                        </div>

                        <div class="section">
                            <span class="section-label">Snap</span>
                            <div class="mr-6 snap-type-container">
                                <div @click="snapToPosition(0, 0, 50, 100)" class="mr-2 snap half" />
                                <div @click="snapToPosition(50, 0, 50, 100)" class="snap half" />
                            </div>
                            <div class="mr-6 snap-type-container">
                                <div @click="snapToPosition(0, 0, 33.3, 100)" class="mr-2 snap third" />
                                <div @click="snapToPosition(33.3, 0, 33.3, 100)" class="mr-2 snap third" />
                                <div @click="snapToPosition(66.6, 0, 33.3, 100)" class="snap third" />
                            </div>
                            <div class="mr-6 snap-type-container">
                                <div class="snap-top">
                                    <div @click="snapToPosition(0, 0, 50, 50)" class="mr-2 snap quarter" />
                                    <div @click="snapToPosition(50, 0, 50, 50)" class="snap quarter" />
                                </div>
                                <div class="snap-top">
                                    <div @click="snapToPosition(0, 50, 50, 50)" class="mr-2 snap quarter" />
                                    <div @click="snapToPosition(50, 50, 50, 50)" class="snap quarter" />
                                </div>
                            </div>

                            <div class="mr-6 snap-type-container">
                                <div class="snap-top">
                                    <div @click="snapToPosition(0, 0, 33.3, 50)" class="mr-2 snap third-half" />
                                    <div @click="snapToPosition(33.3, 0, 33.3, 50)" class="mr-2 snap third-half" />
                                    <div @click="snapToPosition(66.6, 0, 33.3, 50)" class="snap third-half" />
                                </div>
                                <div class="snap-top">
                                    <div @click="snapToPosition(0, 50, 33.3, 50)" class="mr-2 snap third-half" />
                                    <div @click="snapToPosition(33.3, 50, 33.3, 50)" class="mr-2 snap third-half" />
                                    <div @click="snapToPosition(66.6, 50, 33.3, 50)" class="snap third-half" />
                                </div>
                            </div>

                            <div class="snap-type-container">
                                <v-form ref="customSnapForm" :lazy-validation="true" v-model="customSnapFormValid" @submit.prevent>
                                    <v-text-field class="mr-2 custom-snap-input" v-model="customSnapRows" color="#c42111" outlined label="Rows" type="number" min="0" max="12" :rules="[validation.numRange(customSnapRows, 1, 12)]" />
                                    <v-text-field class="mr-3 custom-snap-input" v-model="customSnapCols" color="#c42111" outlined label="Cols" type="number" min="0" max="12" :rules="[validation.numRange(customSnapCols, 1, 12)]" />
                                    <v-text-field class="mr-2 custom-snap-input" v-model="customSnapRow" color="#c42111" outlined label="Row" type="number" min="0" max="12" :rules="[validation.numRange(customSnapRow, 1, customSnapRows)]" />
                                    <v-text-field class="mr-3 custom-snap-input" v-model="customSnapCol" color="#c42111" outlined label="Col" type="number" min="0" max="12" :rules="[validation.numRange(customSnapCol, 1, customSnapCols)]" />
                                    <v-btn class="custom-snap-button" color="#808080" @click="customSnap">Set</v-btn>
                                </v-form>
                            </div>
                        </div>

                        <div class="section mt-4" v-if="type == 'report'">
                            <span class="section-label">Refresh Settings</span>
                            <v-form ref="reportRefreshSettingsForm" :lazy-validation="true" v-model="formValid" @submit.prevent>
                                <!-- <v-switch style="display: inline-block" label="Auto Refresh Enabled" v-model="reportRefreshEnabled" color="#c42111"></v-switch> -->
                                <v-text-field class="refresh-interval mt-2" label="Refresh Interval (min)" outlined v-model="refreshIntervalMinEdit" type="number" min="1" step="1" color="#c42111" @keyup.enter.native="setRefreshInterval" :disabled="!reportRefreshEnabled" :rules="[validation.posNum(refreshIntervalMinEdit, 1)]">
                                    <template v-slot:append>
                                        <v-btn class="mt-1" icon color="#ffffff" @click="setRefreshInterval"><v-icon large>mdi-arrow-right-bold-circle</v-icon></v-btn>
                                    </template>
                                </v-text-field>
                                <div class="refreshing-report-container" @click="refreshReportResults">
                                    <v-icon large :class="{spin: refreshingNow}">mdi-refresh</v-icon>
                                    <span class="timer" v-text="autoRefreshTimeLeftPretty"></span>
                                </div>
                            </v-form>
                        </div>

                        <v-btn class="delete-widget-button" color="#DC3545" @click="deleteClick"><v-icon large>mdi-delete-forever</v-icon></v-btn>
                    </v-container>
                </div>

            </div>
        </div>


    </div>


</template>

<script>
import _ from 'lodash';
import Alarms from '@/views/Alarms';
import Issues from '@/views/Issues';
import GeoMap from '@/views/GeoMapNew';
import ReportWidget from '@/components/TelsasoftDashboard/ReportWidget';
import Dashboard from '@/views/Dashboard';
export default {
    name: 'Widget',
    props: ['widgetObj', 'windowResize', 'widgetIdx', 'totalWidgets', 'autoSnap'],
    components: {
        Alarms,
        Issues,
        GeoMap,
        ReportWidget,
        Dashboard
    },
    data: () => ({
        type: null,
        icon: null,
        id: null,
        showSettings: false,
        showTab: false,
        widgetOffsetLeft: null,
        widgetOffsetTop: null,
        widgetWidth: null,
        widgetHeight: null,
        maxWidth: null,
        maxHeight: null,
        selectedView: null,
        selectedDensity: null,
        //selectedTableauTab: null,
        viewListAll: false,
        widgetCommand: null,
        customSnapFormValid: true,
        customSnapRows: 0,
        customSnapCols: 0,
        customSnapRow: 0,
        customSnapCol: 0,
        formValid: true,
        reportRefreshEnabled: true,
        refreshIntervalMinEdit: null,
        refreshIntervalMin: null,
        clockTickIntervalFunc: null,
        autoRefreshIntervalFunc: null,
        autoRefreshTimeLeftSec: null,
        refreshingNow: false,
        validation: {
            posNum: (value, minValue) => (!isNaN(Number(value)) && Number(value) >= minValue) || `Value must be positive`,
            numRange: (value, min, max) => (!isNaN(Number(value)) && Number(value) >= min && Number(value) <= max) || `Value must be in range (${min},${max})`,
        },

        resizeObserver: null,
        expandWidgetState: null,
        widgetInitialized: false
    }),

    computed: {
        widgetWidthPct: function() {
            let value = this.widgetWidth ? (((this.widgetWidth / (document.getElementById('widgets-area').offsetWidth - 1)) * 100).toFixed(2)) : (0).toFixed(2);
            if(this._isMounted) {
                this.$props.widgetObj.widgetWidthPct = Number(value);
            }
            return value;
        },
        widgetHeightPct: function() {
            let value = this.widgetHeight ? (((this.widgetHeight / (document.getElementById('widgets-area').offsetHeight - 1)) * 100).toFixed(2)) : (0).toFixed(2);
            if(this._isMounted) {
                this.$props.widgetObj.widgetHeightPct = Number(value);
            }
            return value;
        },
        widgetOffsetLeftPct: function() {
            let value = this.widgetOffsetLeft ? (((this.widgetOffsetLeft / (document.getElementById('widgets-area').offsetWidth - 1)) * 100).toFixed(2)) : (0).toFixed(2);
            if(this._isMounted) {
                this.$props.widgetObj.widgetOffsetLeftPct = Number(value);
            }
            return value;
        },
        widgetOffsetTopPct: function() {
            let value = this.widgetOffsetTop ? (((this.widgetOffsetTop / (document.getElementById('widgets-area').offsetHeight - 1)) * 100).toFixed(2)) : (0).toFixed(2);
            if(this._isMounted) {
                this.$props.widgetObj.widgetOffsetTopPct = Number(value);
            }
            return value;
        },

        viewsFavs: function() {
            return this.$props.widgetObj.views.length ? this.$props.widgetObj.views.filter(v => {return v.fav}) : [];
        },
        viewsList: function() {
            return this.viewListAll ? this.$props.widgetObj.views : this.viewsFavs;
        },

        autoRefreshTimeLeftPretty: function() {
            if(this.autoRefreshTimeLeftSec == null) {
                return null;
            }
            return (TELSA.moment("1900-01-01 00:00:00").add(this.autoRefreshTimeLeftSec, 'seconds').format("mm:ss"));
        },

        tableauUrl: function() {
            if(this.type != 'tableau') {
                return null;
            }
            return this.widgetObj.selectedTableauTab ? `${this.$props.widgetObj.tableauRootUrl}/${this.$props.widgetObj.selectedTableauTab.viewUrlName}?${this.$props.widgetObj.tableauUrlParams}` : this.$store.state.batchConfig.tableau.link;
        }
    },

    methods: {
        settingsClick: function() {
            this.showSettings = !this.showSettings;
        },



        setupDraggable: function() {
            let self = this;

            let setup = function dragElement(widgetContainerElement) {
                let mousePosXNew = 0, mousePosYNew = 0, mousePosX = 0, mousePosY = 0;
                let widgetsBoundingBox = widgetContainerElement.offsetParent;
                let widgetTabElement = widgetContainerElement.getElementsByClassName('widget-handle')[0];

                widgetTabElement.onmousedown = dragMouseDown;

                function dragMouseDown(e) {
                    e = e || window.event;
                    e.preventDefault();
                    // get the mouse cursor position at startup
                    mousePosX = e.clientX;
                    mousePosY = e.clientY;
                    document.onmouseup = closeDragElement;

                    self.checkWidgetDimensions();

                    // call a function whenever the cursor moves
                    document.onmousemove = elementDrag;
                }

                function elementDrag(e) {
                    e = e || window.event;
                    e.preventDefault();
                    // calculate the new cursor position
                    mousePosXNew = mousePosX - e.clientX;
                    mousePosYNew = mousePosY - e.clientY;
                    mousePosX = e.clientX;
                    mousePosY = e.clientY;

                    // calc maximum allowed left value
                    let maxLeft = (widgetsBoundingBox.offsetWidth - widgetContainerElement.offsetWidth);

                    // calc maximum allowed top value
                    let maxTop = (widgetsBoundingBox.offsetHeight - widgetContainerElement.offsetHeight);


                    if(widgetContainerElement.offsetLeft < 0) {
                        widgetContainerElement.style.left = '0px';
                    }
                    else if(widgetContainerElement.offsetTop < 0) {
                        widgetContainerElement.style.top = '0px';
                    }
                    else if(widgetContainerElement.offsetLeft > maxLeft) {
                        widgetContainerElement.style.left = `${maxLeft}px`;
                    }
                    else if(widgetContainerElement.offsetTop > maxTop) {
                        widgetContainerElement.style.top = `${maxTop}px`;
                    }
                    else {
                        // set the element's new position
                        self.widgetOffsetLeft = (widgetContainerElement.offsetLeft - mousePosXNew);
                        self.widgetOffsetTop = (widgetContainerElement.offsetTop - mousePosYNew);
                        widgetContainerElement.style.left = `${self.widgetOffsetLeft}px`;
                        widgetContainerElement.style.top = `${self.widgetOffsetTop}px`;
                    }
                    self.$el.style.zIndex = 9; // Make it so that the widget we're dragging is shown above other widgets
                }

                function closeDragElement() {
                    // stop moving when mouse button is released:
                    document.onmouseup = null;
                    document.onmousemove = null;

                    self.setWidgetMaxWidthHeight();
                    self.$el.style.removeProperty('z-index'); // put this widgets z-index back to normal
                }
            };

            setup(this.$el);
        },

        setWidgetMaxWidthHeight: function() {
            let widgetContainerElement = this.$el;
            let widgetsBoundingBox = widgetContainerElement.offsetParent;

            self.maxWidth = ((widgetsBoundingBox.offsetWidth - widgetContainerElement.offsetLeft) - 2); // borders
            self.maxHeight = ((widgetsBoundingBox.offsetHeight - widgetContainerElement.offsetTop) - 2); // borders and widgetTab
            widgetContainerElement.style.maxWidth = self.maxWidth + 'px';
            widgetContainerElement.style.maxHeight = self.maxHeight + 'px';
        },

        setupResizeHandler: function() {
            let self = this;
            let timeoutFunc = null;
            self.resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    const cr = entry.contentRect;
                    self.checkWidgetDimensions();
                    self.widgetWidth = entry.target.offsetWidth;
                    self.widgetHeight = entry.target.offsetHeight;
                }
                self.$el.style.zIndex = 9; // Make it so that the widget we're resizing is shown above other widgets

                // If it's a report widget then tell it to resize the chart
                clearTimeout(timeoutFunc);
                timeoutFunc = setTimeout(function() {
                    if(self.type == 'report') {
                        self.sendWidgetCommand('resize');
                    }
                    self.$el.style.removeProperty('z-index');

                    // wait a bit after to mark this widget ready for looking for changes
                    if(!self.widgetInitialized) {
                        setTimeout(function() {
                            self.widgetInitialized = true;
                        },1000);
                    }

                }, 1000);
            });
            self.resizeObserver.observe(this.$el);
        },

        checkWidgetDimensions: function() {
            // Reset width to maxWidth and height to maxHeight when needed
            let widgetContainerElement = this.$el;
            let width = Number(widgetContainerElement.style.width.split('px')[0]);
            let maxWidth = Number(widgetContainerElement.style.maxWidth.split('px')[0]);
            let height = Number(widgetContainerElement.style.height.split('px')[0]);
            let maxHeight = Number(widgetContainerElement.style.maxHeight.split('px')[0]);
            if(width > maxWidth) {
                widgetContainerElement.style.width = widgetContainerElement.style.maxWidth;
            }
            if(height > maxHeight) {
                widgetContainerElement.style.height = widgetContainerElement.style.maxHeight;
            }
        },

        setInitialPosition: function() {
            let widgetContainerElement = this.$el;
            let widgetsBoundingBox = widgetContainerElement.offsetParent;

            // position
            this.widgetOffsetLeft = ((this.$props.widgetObj.widgetOffsetLeftPct / 100) * widgetsBoundingBox.offsetWidth);
            this.widgetOffsetTop = ((this.$props.widgetObj.widgetOffsetTopPct / 100) * widgetsBoundingBox.offsetHeight);
            widgetContainerElement.style.left = `${this.widgetOffsetLeft}px`;
            widgetContainerElement.style.top = `${this.widgetOffsetTop}px`;

            // Max width and height
            this.setWidgetMaxWidthHeight();

            // size
            this.widgetWidth = ((this.$props.widgetObj.widgetWidthPct / 100) * widgetsBoundingBox.offsetWidth);
            this.widgetHeight = ((this.$props.widgetObj.widgetHeightPct / 100) * widgetsBoundingBox.offsetHeight);
            widgetContainerElement.style.width = `${this.widgetWidth}px`;
            widgetContainerElement.style.height = `${this.widgetHeight}px`;
        },

        snapToPosition: function(left, top, width, height) {
            this.$props.widgetObj.widgetOffsetLeftPct = left;
            this.$props.widgetObj.widgetOffsetTopPct = top;
            this.$props.widgetObj.widgetWidthPct = width;
            this.$props.widgetObj.widgetHeightPct = height;
            this.setInitialPosition();
        },

        customSnap: function() {
            if(this.$refs.customSnapForm.validate() || true) {
                let widthUnit = (100 / Number(this.customSnapCols));
                let heightUnit = (100 / Number(this.customSnapRows));
                let leftUnitOffset = (widthUnit * (this.customSnapCol - 1));
                let topUnitOffset = (heightUnit * (this.customSnapRow - 1));
                this.snapToPosition(leftUnitOffset, topUnitOffset, widthUnit, heightUnit);
            }
        },

        sendWidgetCommand: function(command) {
            if(command == 'clearView') {
                this.widgetCommand = {
                    type: 'clearView',
                    value: null
                };
                this.selectedView = null;
            }
            else if(command == 'setView') {
                this.widgetCommand = {
                    type: 'setView',
                    value: this.selectedView
                };
                if(this.selectedView) {
                    this.selectedDensity = this.selectedView.view_grid_config.gridSmallMode ? 'Compact' : 'Comfortable';
                }
            }
            else if(command == 'setDensity') {
                this.widgetCommand = {
                    type: 'setDensity',
                    value: this.selectedDensity
                };
            }
            else if(command == 'refresh') {
                this.widgetCommand = {
                    type: 'refresh',
                    value: null
                };
            }
            else if(command == 'resize') {
                this.widgetCommand = {
                    type: 'resize',
                    value: null
                };
            }
        },

        deleteClick: function() {
            this.$emit('deleteWidgetClick', {id: this.id, name: this.$props.widgetObj.name});
        },

        setRefreshInterval: function() {
            this.$nextTick(function() {
                if(this.$refs.reportRefreshSettingsForm.validate()) {
                    this.refreshIntervalMin = this.refreshIntervalMinEdit;
                    this.$props.widgetObj.refreshIntervalMin = this.refreshIntervalMin;
                    clearInterval(this.clockTickIntervalFunc);
                    clearInterval(this.autoRefreshIntervalFunc);
                    if(!this.reportRefreshEnabled) {
                        return;
                    }
                    this.autoRefreshTimeLeftSec = Math.round(this.refreshIntervalMin * 60);
                    this.setupAutoRefreshIntervalFunc();
                    let self = this;
                    this.clockTickIntervalFunc = setInterval(function() {
                        if(self.autoRefreshTimeLeftSec > 0) {
                            self.autoRefreshTimeLeftSec = (self.autoRefreshTimeLeftSec - 1);
                        }
                    }, 1000);
                }
                else {
                    // Invalid refresh setting!
                }
            });
        },
        setupAutoRefreshIntervalFunc: function() {
            let refreshIntervalSec = Math.round(this.refreshIntervalMin * 60);
            let self = this;
            clearInterval(this.autoRefreshIntervalFunc);
            this.autoRefreshIntervalFunc = setInterval(function() {
                self.refreshReportResults();
            }, (refreshIntervalSec * 1000));
        },
        refreshReportResults: function() {
            this.refreshingNow = true;
            clearInterval(this.autoRefreshIntervalFunc);
            this.autoRefreshTimeLeftSec = 0; // This normally should already be 0 except when they manually refreshed. Then we need to set it to 0 manually.
            this.sendWidgetCommand('refresh');
        },
        refreshReportResultsComplete: function() {
            this.refreshingNow = false;
            this.setupAutoRefreshIntervalFunc();
            this.autoRefreshTimeLeftSec = Math.round(this.refreshIntervalMin * 60);
        },

        windowResizeHandler: function() {
            // Screen resize handler to keep widgets relative sizes and positions
            this.$props.widgetObj.widgetOffsetLeftPct = this.widgetOffsetLeftPct;
            this.$props.widgetObj.widgetOffsetTopPct = this.widgetOffsetTopPct;
            this.$props.widgetObj.widgetWidthPct = this.widgetWidthPct;
            this.$props.widgetObj.widgetHeightPct = this.widgetHeightPct;
            this.setInitialPosition();
        },

        expandWidget: function() {
            this.$el.classList.add("expanded");
            this.expandWidgetState = {
                widgetOffsetLeftPct: this.widgetOffsetLeftPct,
                widgetOffsetTopPct: this.widgetOffsetTopPct,
                widgetWidthPct: this.widgetWidthPct,
                widgetHeightPct: this.widgetHeightPct
            };
            this.$props.widgetObj.widgetOffsetLeftPct = 10;
            this.$props.widgetObj.widgetOffsetTopPct = 5;
            this.$props.widgetObj.widgetWidthPct = 80;
            this.$props.widgetObj.widgetHeightPct = 90;
            this.setInitialPosition();
        },
        retractWidget: function() {
            this.$el.classList.remove("expanded");
            this.$props.widgetObj.widgetOffsetLeftPct = this.expandWidgetState.widgetOffsetLeftPct;
            this.$props.widgetObj.widgetOffsetTopPct = this.expandWidgetState.widgetOffsetTopPct;
            this.$props.widgetObj.widgetWidthPct = this.expandWidgetState.widgetWidthPct;
            this.$props.widgetObj.widgetHeightPct = this.expandWidgetState.widgetHeightPct;
            this.setInitialPosition();
            this.expandWidgetState = null;
        },

        autoSnapWidget: function() {
            let widgetIdx = this.$props.widgetIdx;
            let totalWidgets = this.$props.totalWidgets;
            let rows = 1;
            if(totalWidgets <= 2) {
                rows = 1;
            }
            else if(totalWidgets <= 10) {
                rows = 2;
            }
            else if(totalWidgets <= 15) {
                rows = 3;
            }
            else {
                rows = Math.ceil(totalWidgets / 5);
            }

            let cols = Math.ceil(totalWidgets / rows);
            let width = 100 / cols;
            let height = 100 / rows;
            let col = widgetIdx % cols;
            let left = width * col;
            let row = Math.floor(widgetIdx / cols);
            let top = height * row;
            this.snapToPosition(left, top, width, height);
        },

        debounceCheckForChanges: _.debounce(function() {
            this.$emit('change');
        }, 500),
    },

    mounted() {
        this.setInitialPosition();
        this.setupDraggable();
        this.setupResizeHandler();

        this.selectedView = this.$props.widgetObj.selectedView || this.viewsFavs.find(v => {return v.default}) || (this.viewsFavs.length ? this.viewsFavs[0] : null);
        if(this.selectedView) {
            this.selectedDensity = this.$props.widgetObj.selectedDensity || this.selectedView.view_grid_config.gridSmallMode ? 'Compact' : 'Comfortable';
        }

        if(this.type == 'report') {
            this.refreshIntervalMin = this.$props.widgetObj.refreshIntervalMin || 15;
            this.refreshIntervalMinEdit = this.refreshIntervalMin;
            this.setRefreshInterval();
        }
        this.sendWidgetCommand('setView');
    },

    created() {
        this.type = this.$props.widgetObj.type;
        this.icon = this.$props.widgetObj.icon;
        this.id = this.$props.widgetObj.id;
    },

    destroyed() {
        clearInterval(this.clockTickIntervalFunc);
        clearInterval(this.autoRefreshIntervalFunc);
        this.resizeObserver.unobserve(this.$el);
        //this.$el.removeEventListener('mousemove', function(event) {});
    },

    watch: {
        selectedView: {
            handler(newVal, oldVal) {
                this.$props.widgetObj.selectedView = newVal;
            },
        },

        selectedDensity: {
            handler(newVal, oldVal) {
                this.$props.widgetObj.selectedDensity = newVal;
            },
        },

        windowResize: {
            handler(newVal, oldVal) {
                this.windowResizeHandler();
            }
        },

        autoSnap: {
            handler(newVal, oldVal) {
                this.autoSnapWidget();
            }
        },

        widgetObj: {
            handler(newVal, oldVal) {
                if(this.widgetInitialized) {
                    this.debounceCheckForChanges()
                }
            },
            deep: true
        }
    },
};
</script>

<style scoped>



    .widget-container {
        position: absolute;
        resize: both;
        overflow: auto;
        /* min-width: 320px;
        min-height: 320px; */
        z-index: 5;
    }
    .widget-container:hover {
        z-index: 6;
    }
    .widget-container.expanded {
        z-index: 10;
    }

    .widget-container .flip-card {
        border: #ffffff3d solid 1px;
        background-color: #424242;
        /* border-radius: 5px; */
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        box-shadow: 4px 4px 5px 0px rgba(0,0,0,1);
        /* z-index: 5; */
        position: relative;
        perspective: 1000px;
        width: 100%;
        height: calc(100% - 40px);
        top: 40px;
    }
    .widget-container .flip-card.tab-active {
        border-top-left-radius: 0px;
    }

    .widget-container .flip-card .flip-card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        /* text-align: center; */
        transition: transform 0.6s;
        transform-style: preserve-3d;
    }
    .widget-container .flip-card .flip-card-inner.settings {
        transform: rotateY(180deg);
    }

    .widget-container .flip-card .flip-card-inner .widget-content {
        position: absolute;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        /* z-index: 1; */
    }

    .widget-container .flip-card .flip-card-inner .widget-metadata {
        position: absolute;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        transform: rotateY(180deg);
        /* z-index: 1; */

        overflow: auto;
    }

    .widget-container .flip-card .flip-card-inner .widget-metadata .delete-widget-button {
        position: absolute;
        top: 0px;
        right: 0px;
        height: 55px;
        width: 30px;
        border-radius: 0px;
        /* border-top-right-radius: 5px; */
        border-bottom-left-radius: 5px;
    }

    .widget-metadata .type-icon {
        margin-top: -4px;
        text-align: center;
        width: 100%;
    }
    .widget-metadata .section {
        display: block;
        text-align: left;
        margin-top: 0px;
    }
    .widget-metadata .section-label {
        display: block;
        font-size: 16px;
        margin-bottom: 5px;
    }
    .widget-metadata .input-field {
        display: inline-block;
        margin-right: 15px;
        width: 100px;
        max-width: 150px;
    }


    .widget-option-select {
        /* min-width: 400px; */
        width: 400px;
        /* width: 50%; */
        display: inline-block;
    }
    .favsToggle {
        display: inline-block;
        margin: 0px 0px 0px 10px;
    }


    /* .view-select-container {
        position: relative;
        display: inline-block;
    }
    .view-select {
        width: 250px;
        display: inline-block;
    } */
    .view-select-default-text {
        color: yellow;
        position: absolute;
        right: 20px;
        text-align: right;
        font-size: 11px;
        font-weight: bold;
    }



    .snap-type-container {
        display: inline-block;
        vertical-align: text-top;
    }
    .snap {
        background-color: gray;
        border: #ffffff3d solid 1px;
        cursor: pointer;
        box-shadow: 4px 4px 5px 0px rgba(0,0,0,0.75);
    }
    .snap.half {
        display: inline-block;
        height: 60px;
        width: 60px
    }
    .snap.third {
        display: inline-block;
        height: 60px;
        width: 40px
    }
    .snap-top {
        display: block;
    }
    .snap.quarter {
        display: inline-block;
        height: 30px;
        width: 60px
    }
    .snap.third-half {
        display: inline-block;
        height: 30px;
        width: 40px
    }
    .custom-snap-input {
        display: inline-block;
        width: 80px;
    }
    .custom-snap-button {
        height: 56px !important;
        border: solid 1px #c0c0c0 !important;
        margin-top: -2px;
    }

    .refresh-interval {
        display: inline-block;
        width: 180px;
    }
    
    .refreshing-report-container {
        display: inline-block;
        margin-left: 1em;
        border: rgba(0, 0, 0, 0.2) solid 1px;
        background-color: rgba(255, 255, 255, 0.15);
        padding: 5px 5px 4px 5px;
        border-radius: 3px;
        cursor: pointer;

        height: 56px;
        vertical-align: top;
        margin-top: 8px;
        border: solid 1px #c0c0c0;
        padding-top: 9px;
    }
    .refreshing-report-container:hover {
        background-color: rgba(255, 255, 255, 0.35);
    }
    .refreshing-report-container .timer {
        vertical-align: top;
        font-weight: 500;
        font-size: 24px;
    }
    .refreshing-report-container i.spin {
        animation-name: spin;
        animation-duration: 1000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }







    .widget-container.alarms ::-webkit-resizer {
        /* width: 15px;
        height: 15px; */
        /* border-bottom-right-radius: 5px;
        background-color: pink; */

        /* background-image: url("data:image/svg+xml,***<here place encoded svg>***"); */
        /* background: url('https://api.iconify.design/mdi-resize-bottom-right.svg?width=5&height=5') no-repeat center center; */


        background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20aria-hidden%3D%22true%22%20focusable%3D%22false%22%20width%3D%221em%22%20height%3D%221em%22%20style%3D%22-ms-transform%3A%20rotate(360deg)%3B%20-webkit-transform%3A%20rotate(360deg)%3B%20transform%3A%20rotate(360deg)%3B%22%20preserveAspectRatio%3D%22xMidYMid%20meet%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M22%2022h-2v-2h2v2m0-4h-2v-2h2v2m-4%204h-2v-2h2v2m0-4h-2v-2h2v2m-4%204h-2v-2h2v2m8-8h-2v-2h2v2z%22%20fill%3D%22%23ffffff%22%2F%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2224%22%20height%3D%2224%22%20fill%3D%22rgba(0%2C%200%2C%200%2C%200)%22%20%2F%3E%3C%2Fsvg%3E");
        background-repeat: no-repeat;
    }
    .widget-container.geomap ::-webkit-resizer {
        width: 5px;
        height: 5px;
        border-right: 5px solid orange;
        border-bottom: 5px solid orange;
        border-bottom-right-radius: 5px;
        background-color: orange;
    }


    ::-webkit-resizer {
        /* border: 5px solid yellow;
        background: blue;
        z-index: 99999999999999; */

        /* box-shadow: 0 0 2px 5px red; */
        /* outline: 2px dashed green; */

        /*size does not work*/
        /* display:block;
        width: 150px !important;
        height: 150px !important; */


        /* border: 5px solid gray; */

        /* width: 5px;
        height: 5px;
        border-bottom-right-radius: 5px;
        background-color: gray; */

        /* content: url('https://api.iconify.design/mdi-resize-bottom-right.svg?color=%23ffffff&width=10&height=10');
        vertical-align: -0.125em; */





        /* background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20aria-hidden%3D%22true%22%20focusable%3D%22false%22%20width%3D%221em%22%20height%3D%221em%22%20style%3D%22-ms-transform%3A%20rotate(360deg)%3B%20-webkit-transform%3A%20rotate(360deg)%3B%20transform%3A%20rotate(360deg)%3B%22%20preserveAspectRatio%3D%22xMidYMid%20meet%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M22%2022h-2v-2h2v2m0-4h-2v-2h2v2m-4%204h-2v-2h2v2m0-4h-2v-2h2v2m-4%204h-2v-2h2v2m8-8h-2v-2h2v2z%22%20fill%3D%22%23ffffff%22%2F%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2224%22%20height%3D%2224%22%20fill%3D%22rgba(0%2C%200%2C%200%2C%200)%22%20%2F%3E%3C%2Fsvg%3E");
        background-repeat: no-repeat; */

        /* background: url('https://api.iconify.design/mdi-resize-bottom-right.svg?color=%23ffffff&width=20&height=20') no-repeat center center; */
    }




    .widget-handle {
        position: absolute;
        background-color: #c42111;
        top: 0px;
        width: 100%;
        cursor: grab;
        /* box-shadow: 2px 3px 3px 2px rgba(0,0,0,0.75); */
        border-bottom: solid 1px #ffffff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        z-index: 5;
        height: 40px;
        left: 0px;
    }


    .widget-handle .widget-handle-details-container {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .widget-handle .widget-handle-details-container .widget-type-icon {
        display: inline-block;
        position: absolute;
        top: 6px;
        left: 12px;
    }

    .widget-handle .widget-handle-details-container .widget-name {
        display: inline-block;
        position: absolute;
        left: 45px;
        top: 9px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        /* width: 210px; */
        width: 170px;
    }

    .widget-handle .widget-handle-details-container .report-timer {
        text-align: center;
        display: block;
        font-weight: 500;
        padding-top: 7px;
        width: 60px;
        cursor: pointer;
        margin-left: calc(50% - (60px / 2));
    }

    .widget-handle .widget-handle-details-container .widget-settings-icon {
        display: inline-block;
        position: absolute;
        right: 12px;
        top: 8px;
    }

    .widget-handle .widget-handle-details-container .widget-expand-icon {
        display: inline-block;
        position: absolute;
        right: 36px;
        top: 6px;
    }

    .widget-handle .widget-handle-details-container .handle-hide-icon {
        display: inline-block;
        position: absolute;
        right: 62px;
        top: 6px;
    }

</style>



